import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';

//context
import DashboardContext from '../../contexts/DashboardContext';

//importing widgets
import CertificationsDue from './widgets/CertificationsDue/CertificationsDue';
import FindingsOverview from './widgets/FindingsOverview/FindingsOverview';
import OpenFindings from './widgets/OpenFindings/OpenFindings';
import TeamManagement from './widgets/TeamManagement/TeamManagement';
import InspectionsDue from './widgets/InspectionsDue/InspectionsDue';
import Calendar from './widgets/Calendar/Calendar';
import Precipitation from './widgets/Precipitation'
// import ComplianceMetrics from './widgets/ComplianceMetrics/ComplianceMetrics';
import Permits from './widgets/Permits/Permits';

type Props = {
    provide: any;
    ele: any;
    index: number;
    showMore: boolean;
}

const GridItem = (props: Props) => {

    const { dashboardWidgetSizeHolder, setDashboardWidgetSizeHolder } = useContext(DashboardContext);

    const [mdSize, setMdSize] = useState(dashboardWidgetSizeHolder[props.ele] || 6);

    const callComponent = (ele: String, provided: any, changeShowMore: Function) => {
        switch (ele) {
            case 'Findings Overview':
                return <FindingsOverview providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            case 'Certifications Due':
                return <CertificationsDue providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            case 'Open Findings':
                return <OpenFindings providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            case 'Team Management':
                return <TeamManagement providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            case 'My Projects':
                return <InspectionsDue providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            case 'Calendar':
                return <Calendar providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            case 'Precipitation':
                return <Precipitation providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            // case 'Compliance Metrics':
            //   return <ComplianceMetrics providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;
            case 'Permits':
                return <Permits providedProps={provided.dragHandleProps && provided.dragHandleProps["data-rbd-drag-handle-context-id"]} changeShowMore={changeShowMore} mdSize={mdSize} />;

            default:
                return null;
        }
    };

    const changeShowMore = () => {
        let tempArr = dashboardWidgetSizeHolder;

        if (tempArr[props.ele] === 6) {
            tempArr[props.ele] = 12;
        } else {
            tempArr[props.ele] = 6;
        }
        setMdSize(tempArr[props.ele])
        setDashboardWidgetSizeHolder(tempArr);
        localStorage.setItem("hasChanged", "true")
        localStorage.setItem("widgetSizeHolder", JSON.stringify(tempArr))
    }

    useEffect(()=>{ 
        let tempHolder:any

        if(localStorage.getItem("widgetSizeHolder")){
            tempHolder = localStorage.getItem("widgetSizeHolder")
            tempHolder = JSON.parse(tempHolder)
            setDashboardWidgetSizeHolder(tempHolder)
            setMdSize(tempHolder[props.ele])
        }
        else{
            setMdSize(6)
        }

    },[localStorage.getItem("widgetSizeHolder")])
    
    useEffect(()=>{
        let tempHolder:any
        let hasChanged = localStorage.getItem("hasChanged")
        
        if(localStorage.getItem("widgetSizeHolder") && hasChanged === "false"){
            tempHolder = localStorage.getItem("widgetSizeHolder")
            tempHolder = JSON.parse(tempHolder)

            if (props.showMore) {
                tempHolder[props.ele] = 12;
                setDashboardWidgetSizeHolder(tempHolder)
                localStorage.setItem("widgetSizeHolder", JSON.stringify(tempHolder))
            } else {
                tempHolder[props.ele] = 6;
                setDashboardWidgetSizeHolder(tempHolder)
                localStorage.setItem("widgetSizeHolder", JSON.stringify(tempHolder))
            }
        }
    },[props.showMore])

    return (
        <Grid item xs={12} md={mdSize}>
            <div
                ref={props.provide.innerRef}
                {...props.provide.draggableProps}
                {...props.provide.dragHandleProps}
            >
                <div>{callComponent(props.ele, props.provide, changeShowMore)}</div>
            </div>
        </Grid>
    )
}

export default GridItem
